export enum ApiErrors {
  MissingOTP = 'otp required',
  InvalidOTP = 'invalid otp',
  InvalidEmailOrPassword = 'invalid email or password',
  InvalidCredentials = 'invalid credentials',
  InvitationNotFound = 'invitation not found',
  MfaRequired = 'mfa required',
  InvalidSession = 'invalid session',
  UserAlreadyExists = 'a user with this email address already exists',
  NoAdminsLeft = 'No admins left in organization',
  Unauthenticated = 'unauthenticated',
  NoSession = 'no session',
  ForgotPasswordTokenExpired = 'token expired',
  RequiresClearingTenant = 'requires clearing tenant',
  RequiresClearingOrProgramTenant = 'requires program or clearing tenant',
  RequiresProgramTenant = 'requires program tenant',
  AccountNotFoundOrNotInProgram = 'account not found or not in program',
  TenantNotPermitted = 'tenant not permitted',
  AccountNotFound = 'account not found',
}

export class APIError extends Error {
  status: number;

  requestIdentifier: string;

  traceId: string;

  constructor(status: number, requestIdentifier: string, traceId: string, errorResponse: any) {
    const message = errorResponse?.error || errorResponse?.message || status;

    super(message);

    this.name = 'APIError';
    this.status = status;
    this.requestIdentifier = requestIdentifier;
    this.traceId = traceId;
  }
}
